import { useEffect, useState } from 'react';

import { Flex, Label, Slider, Switch } from '@raystack/apsara';

import { Show } from '@src/hoc';

import styles from './style.module.css';

export default function MultiRangeSlider({
  min,
  max,
  name,
  onChange,
  curMin,
  curMax,
  units,
  checked,
  setChecked,
  showToggle = true,
  staticVal = 0
}) {
  const [tMin, setTMin] = useState(0);
  const [tMax, setTMax] = useState(100);
  const [error, setError] = useState('');

  useEffect(() => {
    setTMax(curMax);
    setTMin(curMin);
    if (curMax <= 100 && curMin >= 0) setError('');
  }, [curMax, curMin]);

  return (
    <Flex className={styles.rangeWrapper} direction='column' gap='large'>
      {checked !== null ? (
        <div className='w-full flex justify-between'>
          <Label
            size='medium'
            style={
              checked
                ? { color: 'var(--rs-color-foreground-base-primary)' }
                : { color: 'var(--rs-color-foreground-base-secondary)' }
            }
          >
            {name}
          </Label>
          <Show
            when={showToggle}
            fallback={<Label size='medium'>{staticVal}</Label>}
          >
            <Switch id={name} checked={checked} onCheckedChange={setChecked} />
          </Show>
        </div>
      ) : (
        <div className='w-full flex justify-between'>
          <Label
            type='secondary'
            size='medium'
            style={{ color: 'var(--rs-color-foreground-base-primary)' }}
          >
            {name}
          </Label>
        </div>
      )}

      <Show when={checked || checked == null}>
        <Slider
          data-test-id='range-slider'
          variant='range'
          value={[curMin, curMax]}
          min={min}
          max={max}
          step={1}
          label={[`${curMin}${units}`, `${curMax}${units}`]}
          onChange={onChange}
          thumbSize='large'
        />
      </Show>
    </Flex>
  );
}
